<app-header></app-header>

<section class="bredcrumb">
    <div class="container">
        <ul class="brd-nav">
            <li> <a [routerLink]="['/']"> Home </a></li>
            <li> <a [routerLink]="['/doctors/list']"> Doctors </a></li>
            <li><span> Tele Medicine</span></li>
        </ul>
    </div>
</section>
<!--- End of bredcrumb --->

<section class="single-page doctors-detail doctors-detail-chat padd-row">
    <div class="container">
        <div class="row">
            <!-- <div class="col-lg-4">
                <div class="doc-detail-lft p-0 sidebar">

                    <div class="doc-detail-box grey-bg p-25-side mb-4">
                        <div class="doc-chat-box-main">
                            <p>Hello {{ username }}, Please let us know the problem you are facing?</p>

                            <div class="consult_data">
                                <div class="row">
                                    <div class="col-md-12 color mb-3" *ngFor="let speciality of specialities"
                                        (click)="setSpeciality(speciality)"
                                        [ngClass]="{'grey': selectedSpecilaity!=speciality, 'selected':selectedSpecilaity==speciality }">
                                        <p> {{ speciality }} </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div> -->

            <div class="offset-md-2 col-md-8">
                <div class="white-bg-shadow doc-chat-right-side white-bg-shadow_hidden">
                    <div class="doc-chat-header">
                        <h3> Consult with Doctor </h3>
                    </div>

                    <div class="d_text">
                        D
                    </div>
                    <div class="doc-detail-box grey-bg p-25-side mb-4 mt-3">
                        <div class="doc-chat-box-main">
                            <p>Select the relevant speciality for your health problem</p>

                            <div class="consult_data">
                                <div class="row">
                                    <div class="col-md-5 color mb-3 ml-3" *ngFor="let speciality of specialities"
                                        (click)="messages = [];setSpeciality(speciality);scrollWhenClick()"
                                        [ngClass]="{'grey': selectedSpecilaity!=speciality, 'selected':selectedSpecilaity==speciality }">
                                        <p> {{ speciality }} </p>
                                    </div>
                                    <div class="col-md-5 color i_dont_know  mb-3 ml-3" (click)="messages = [];dontKnowSelected();scrollWhenClick()">
                                        <p class="mb-0">I Don't Know</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div #scrollMe class="doc-chat-body">
                        <div *ngFor="let message of messages"
                            [ngClass]="message.sentBy=='BOT' ? 'doc-chat-box-row clearfix' : 'doc-chat-box-row doc-chat-box-row-doc clearfix'">
                            <div class="doc-chat-box-main">
                                <div class="d_text" *ngIf="message.sentBy=='BOT'" style="left: -20px;top: 0;">
                                    D
                                </div>
                                <div class="u_text" *ngIf="message.sentBy!='BOT'">
                                    U
                                </div>
                                <div *ngIf="message.messageType=='TEXT' || !message.messageType" [class.margin-left-40]="message.sentBy=='BOT'"
                                [class.margin-right-40]="message.sentBy != 'BOT'"
                                    class="doc-chat-box-cnt">
                                    <p *ngIf="!message.pay || (!!message.pay && !payAmount)"> {{ message.message }} </p>
                                    <p *ngIf="!!message.pay && !!payAmount"> Pay Rs. {{payAmount}} to Consult with Doctor </p>
                                    <button class="btn btn-style" (click)="payWithRazor()" *ngIf="message.pay && !!payAmount"> 
                                        Pay
                                    </button>
                                    <button class="btn btn-style" (click)="applyPromocode()" *ngIf="message.pay && !!payAmount" style="margin-left: 20px;"> 
                                        Apply Promocode
                                    </button>
                                    <button class="btn btn-style" (click)="bookNow()" *ngIf="message.pay && !payAmount"> 
                                        Book Now
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                <div *ngIf="messageEnable" class="doc-chat-ftr white-bg-shadow">
                    <div class="doc-chat-ftr-box">
                        <div class="doc-chat-ftr-box-lft">

                            <input type="text" (keyup.enter)="sendMessage()" [(ngModel)]="inputMessage"
                                class="form-control" placeholder="Write something here..">
                        </div>
                        <div class="doc-chat-ftr-box-right">
                            <a [routerLink]="null" (click)="sendMessage()" class="btn-style"> Send </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<ngx-spinner></ngx-spinner>